import { Box, Card, Grid, Typography } from "@mui/material";		
import moment from "moment";		
import { useNavigate } from "react-router-dom";		

const UpdatesTraceCommunications = ({ traceCommunication }) => {		
    const navigate = useNavigate()		
    const handleBoxClick = (id: any) => {		
        navigate(`/atom-pro/income-tax-tan/traces-communication`);		
    };		
    return (		
        <>		
             {traceCommunication && traceCommunication?.newItem && traceCommunication?.newItem?.length > 0 && (		
                <Grid container spacing={1}>		
                    <Grid item xs={12}>		
                        <Typography variant="h5" color={"primary"}>Traces Inbox : {traceCommunication?.newItem?.length}</Typography>		
                    </Grid>		

                    {traceCommunication?.newItem?.map(item => (		
                        <Grid item xs={4} key={item.id}>		
                            <Card >		
                                <Grid item sx={{ marginBottom: 1 }} onClick={() => handleBoxClick(item.id)} bgcolor={"#ffffff"} m={0.5} padding={0.5}>		
                                    <Typography variant="body2"> <span style={{ fontWeight: "600", color: "#00264d" }}>Common Reference No : </span> {item?.commRefNo}</Typography>		
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Financial Year : </span> {item?.financialYear}</Typography>		
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Form Type : </span> {item?.formType}</Typography>		
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Quarter : </span> {item?.quarter}</Typography>		
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Date : </span> {item?.date ? item?.date : '--'}</Typography>		
                                </Grid>		
                            </Card>		
                        </Grid>		
                    ))}		
                </Grid>		
            )}		
        </>		
    )		
};		

export default UpdatesTraceCommunications;